module.exports = __webpack_public_path__ + "img/rakuten@2x.733a5a35.jpg";